export type SubscriptionManagerType = 'parent' | 'student';

type SubscriptionLike = {
  parent_id?: string | null;
  student_id?: string | null;
  manager_type?: string | null;
  manager_profile_id?: string | null;
  management_locked?: boolean | null;
  management_unlock_at?: string | null;
  status?: string | null;
  current_period_end?: string | null;
};

export function getSubscriptionManagerType(subscription: SubscriptionLike | null | undefined): SubscriptionManagerType | null {
  if (!subscription) return null;
  if (subscription.manager_type === 'parent' || subscription.manager_type === 'student') {
    return subscription.manager_type;
  }
  return subscription.parent_id ? 'parent' : 'student';
}

export function isStudentManagedSubscription(subscription: SubscriptionLike | null | undefined): boolean {
  return getSubscriptionManagerType(subscription) === 'student';
}

export function isParentManagedSubscription(subscription: SubscriptionLike | null | undefined): boolean {
  return getSubscriptionManagerType(subscription) === 'parent';
}

export function getSubscriptionManagementUnlockAt(subscription: SubscriptionLike | null | undefined): string | null {
  if (!subscription) return null;
  if (subscription.management_unlock_at) return subscription.management_unlock_at;
  if (isStudentManagedSubscription(subscription) && ['active', 'past_due'].includes(String(subscription.status || ''))) {
    return subscription.current_period_end || null;
  }
  return null;
}

export function isParentManagementLocked(subscription: SubscriptionLike | null | undefined): boolean {
  if (!subscription) return false;
  if (typeof subscription.management_locked === 'boolean') {
    return subscription.management_locked;
  }
  return isStudentManagedSubscription(subscription) && ['active', 'past_due'].includes(String(subscription.status || ''));
}
